<template>
<a v-if="data['type'] && screenWidth > 768" class="gi-cardb" :href="data.link" target="_blank">
  <div class="image">
    <img :src="data['图片']">
  </div>
  <div class="content">
    <h1 class="title">{{data.title}}</h1>
    <p class="intro">{{data.description}}</p>
  </div>
</a>
<a v-else class="gi-card" @click="linkTo()" :href="data.link" target="_blank">
  <div class="image">
    <img :src="data['图片']">
  </div>
  <div class="content">
    <h1 class="title">{{data.title}}</h1>
    <p class="intro">{{data.description}}</p>
  </div>
</a>
</template>

<script>
export default {
  props: ['data', 'type', 'hasPlay', 'screenWidth', 'i'],
  methods: {
    linkTo (link) {
      if (this.type === 'news') {
        window._hmt.push(['_trackEvent', 'infoq_button', 'click', `news_${this.i + 1}`])
      } else if (this.type === 'case') {
        window._hmt.push(['_trackEvent', 'infoq_button', 'click', `case_${this.i + 1}`])
      }
    }
  }
}
</script>

<style lang="sass" scoped>
$title-primary: #1075d4

=mobile
  @media screen and (max-width: 768px)
    @content

=tablet
  @media screen and (min-width: 769px)
    @content


.image
  position: relative
  display: flex
  align-items: center
  justify-content: center
  .play
   position: absolute
   width: 45px

a.gi-card:hover
  box-shadow: 0 8px 16px 0 rgba(7,17,27,.2)
  transition: all 0.3s
  transform: scale(1.02, 1.02)
  h1
    color: #1273c4
.gi-card, .gi-cardb
  display: block
  background: #fff
  // border: 1px solid #eee
  img
    width: 100%
  .content
    // background-color: #fff
    padding: 15px
    +mobile
      padding: 15px
  h1
    font-size: 16px
    color: #333
    height: 50px
    +mobile
      font-size: 16px
  p
    margin-top: 5px
    font-size: 14px
    overflow: hidden
    text-overflow: ellipsis
    display: -webkit-box
    -webkit-line-clamp: 2
    /*! autoprefixer: ignore next */
    -webkit-box-orient: vertical
  .tip
    margin-top: 20px
    font-size: 12px
    +mobile
      margin-top: 15px
.gi-cardb
  position: relative
  .content
    position: absolute
    bottom: 0
    left: 0
    color: #fff
    h1
      color: #fff
      font-weight: bold
      font-size: 18px
</style>
